'use strict';

// Used on mogo.ca/account-activation?token=
// AND account settings change email
function EmailVerification() {
  this.id = null;
  this.node = null;
  this.declaredClass = null;

  // Page Properties to be defined through
  // data-mogo-page-* attributes
  this.onActivated = null;
  this.confirmEmail = null;
  this.failedMessage = null;

  this.extends = [_Secured, _Routes];
  this._session = new Session();

  this.init = function () {
    var activation_token = getURLParameter('token').trim(0);

    if (activation_token == null) {
      $('h1.h3.message').html(this.failedMessage);
    } else {
      var data = {
        confirmation_token: activation_token.trim()
      };
      var request = new APIRequest(this.confirmEmail, 'POST', data, $.proxy(this._onEmailVerification, this));
      request.send();
    }
  };

  this.initAllReady = function () {};

  this._onEmailVerification = function (data, response) {
    var h = new History();
    if (data.errors) {
      if (data.errors[0].key == 'member_service_account_already_confirmed' || data.errors[0].key == 'member_service_email_not_found') {
        location.replace((this._session._auth_token ? this._DEFAULT_LOGGEDIN_PATH : this._LOGIN_PATH) + '?notification=already-verified');
      } else {
        $('h1.h3.message').html(this.failedMessage);
      }
    } else {
      var tracking = getURLParameter('tracking') ? '&tracking=' + getURLParameter('tracking').trim(0) : '';
      this._session.setAuthToken(data.auth_token);
      this._session.setBearerToken(data.bearer_token);
      this._session.setRefreshToken(data.refresh_token);

      if (!this.onActivated) {
        // onboarding case (doesnt specify onActivated in pug)
        // Phase 1
        h.goToUrl(this.paths.signup.create_profile);
        location.replace(this.paths.signup.create_profile + '?notification=email-verified' + tracking);
        // Phase 2...
        // h.goToUrl(this.paths.signup.product_interests);
        // location.replace(this.paths.signup.product_interests + '?notification=email-verified' + tracking);
      } else {
        // edit email case
        // Set new URL so referred is picked up as dashboard instead of verify email page
        h.goToUrl(this.paths.signup.create_profile);
        location.replace(this.onActivated + tracking);
      }
    }
  };
}